export const PAYMENT_METHOD_ORDER = {
  DELIVERY: 1,
  ONLINE: 2,
} as const;

export const MIN_PHONE_LENGTH = 4;
export const MIN_PHONE_LENGTH_WITH_COUNTRY = 10;
export const MAX_PHONE_LENGTH_WITH_COUNTRY = 11;
export const COUNTRY_CODE = "55";

export const DEFAULT_PRIORITY = 1;
export const MAX_PRIORITY_OPTIONS = 5;
